// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--3pyIY","switcher":"styles-module--switcher--2IHhY","childrenWrapper":"styles-module--childrenWrapper--tdUdi","visible":"styles-module--visible--23zzH"};